import { useDispatch, useSelector } from "react-redux";
import { checkRoleHasAccess, selectRoleByPriority } from "./RolesConfig";
import { RootState } from "../../store";
import { setUserSelectedRole } from "store/reducers/user";
// import Errors from "../error/Errors";
interface PropsModel {
    children: React.ReactNode
    validatorName: string
}
const UserRoleValidator = (props: PropsModel) => {
    const { children, validatorName } = props;
    const dispatch = useDispatch();
    const updatedRoles = [];
    const userData = useSelector((state: RootState) => state.user.userProfile)
    const userSelectedRole = useSelector((state: RootState) => state.user.userSelectedRole);
      // Extract userRoles safely
    const userRoles = userData?.userRole || [];
    // Add selected role or default role based on priority
    if (userSelectedRole) {
        updatedRoles.push(userSelectedRole);
    } else {
        const defaultRole = selectRoleByPriority(userRoles);
        if (defaultRole) {
            updatedRoles.push(defaultRole);
            dispatch(setUserSelectedRole(defaultRole));
        }
    }
    const isValid = !validatorName || checkRoleHasAccess(updatedRoles, validatorName);
    if (isValid) return <>{children}</>;
    return <></> 
};


export default UserRoleValidator;
